import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { IngestionEditForm } from "./components/IngestionEditForm";

export function EditIngestionPage() {
  return (
    <Page title="Edit Ingestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <IngestionEditForm />
      </Container>
    </Page>
  );
}
